const returnDepartmentAndBtiByResponse = (response) => {
  const tempDepartments = {}
  const tempBtiCode = {}
  response.forEach(dep => {
    if (!tempDepartments[dep.Department]) {
      tempDepartments[dep.Department] = {
        id: dep.Department,
        label: dep.Department,
        children: {}
      }
    }
    dep.subDepartments.forEach(subdep => {
      const uniqueSubDepartmentId = `${dep.Department}-${subdep.Group}`
      tempDepartments[dep.Department].children[uniqueSubDepartmentId] = {
        id: uniqueSubDepartmentId,
        label: subdep.Group,
        linkedTo: []
      }
      subdep.Maingroup.forEach(group => {
        if (!tempBtiCode[group.maingroup_cd]) {
          tempBtiCode[group.maingroup_cd] = {
            id: group.maingroup_cd,
            label: group.maingroup_cd + ' - ' + group.maingroup_desc,
            children: {}
          }
        }
        group.SubGroup.forEach(subgroup => {
          if (!tempBtiCode[group.maingroup_cd].children[subgroup.mainsubgroup_cd]) {
            tempBtiCode[group.maingroup_cd].children[subgroup.mainsubgroup_cd] = {
              id: subgroup.mainsubgroup_cd,
              label: subgroup.mainsubgroup_cd + ' - ' + subgroup.mainsubgroup_desc,
              linkedTo: [uniqueSubDepartmentId]
            }
          } else {
            tempBtiCode[group.maingroup_cd].children[subgroup.mainsubgroup_cd].linkedTo.push(uniqueSubDepartmentId)
          }
          if (!tempDepartments[dep.Department].children[uniqueSubDepartmentId].linkedTo.includes(subgroup.mainsubgroup_cd)) {
            tempDepartments[dep.Department].children[uniqueSubDepartmentId].linkedTo.push(subgroup.mainsubgroup_cd)
          }
        })
      })
    })
    tempDepartments[dep.Department].children = Object.values(tempDepartments[dep.Department].children)
  })
  const result = {
    departmentList: Object.values(tempDepartments),
    btiCodeList: Object.values(tempBtiCode)
  }
  result.btiCodeList.forEach(code => {
    code.children = Object.values(code.children)
  })
  return result
}

const isApiTimeoutResponse = (response) => {
  return response.data && response.data.entityID === 'cloudfoundry-saml-login'
}

const isApiArrayResponse = (response) => {
  return Array.isArray(response.data)
}

export {
  returnDepartmentAndBtiByResponse,
  isApiTimeoutResponse,
  isApiArrayResponse
}
